import kefuQrCode from "@/assets/images/kefu/kefu-01.png";
import { useScrollLock } from "@/hooks/useScrollLock";
import { Grid, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import "./ContactInfoModal.less";

interface ContactInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const ContactInfoModal: React.FC<ContactInfoModalProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  // 防止移动端滚动穿透
  useScrollLock(open);

  // PC端布局
  const renderDesktopContent = () => (
    <div className="contact-modal-desktop">
      {/* 左侧：联系信息区域 */}
      <div className="contact-modal-desktop__left">
        <h2 className="contact-modal-desktop__title">
          {t("contact_modal.title")}
        </h2>

        {/* Live Chat */}
        <div className="contact-modal-desktop__section">
          <div className="contact-modal-desktop__label">
            {t("contact_modal.live_chat")}
          </div>
          <div className="contact-modal-desktop__text">
            {t("contact_modal.chat_desc")}
          </div>
          {/* <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              // 触发在线客服
            }}
            className="contact-modal-desktop__link"
          >
            {t("contact_modal.start_chat")} →
          </a> */}
        </div>

        {/* Support Email */}
        <div className="contact-modal-desktop__section">
          <div className="contact-modal-desktop__label">
            {t("contact_modal.support_email")}
          </div>
          <a className="contact-modal-desktop__email-link">
            Send us an email at info@gen-optima.com for inquiries.
          </a>
        </div>

        {/* Support Phone */}
        <div className="contact-modal-desktop__section contact-modal-desktop__section--compact">
          <div className="contact-modal-desktop__label">
            {t("contact_modal.support_phone")}
          </div>
          <div className="contact-modal-desktop__phone">
            Call us at +1-(862) 235-0594 for immediate assistance.
          </div>
          <div className="contact-modal-desktop__phone-desc">
            {t("contact_modal.immediate_assistance")}
          </div>
        </div>

        {/* FAQ 问题解答 */}
        <div className="contact-modal-desktop__section contact-modal-desktop__section--compact">
          <div className="contact-modal-desktop__label">
            {t("contact_modal.faq_label")}
          </div>
          <div className="contact-modal-desktop__text">
            {t("contact_modal.faq_desc")}
          </div>
        </div>

        {/* 分割线 */}
        {/* <div className="contact-modal-desktop__divider" /> */}

        {/* FAQ链接 */}
        {/* <div className="contact-modal-desktop__faq">
          <span>{t("contact_modal.simple_question")} </span>
          <a href="/faq" className="contact-modal-desktop__faq-link">
            {t("contact_modal.visit_faq")}
          </a>
        </div> */}
      </div>

      {/* 右侧：二维码区域 */}
      <div className="contact-modal-desktop__right">
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="contact-modal-desktop__close-btn"
          aria-label="Close"
        >
          ×
        </button>

        {/* 二维码 */}
        <div className="contact-modal-desktop__qr-wrapper">
          <img
            src={kefuQrCode}
            alt="QR Code"
            className="contact-modal-desktop__qr-image"
          />
        </div>

        {/* 扫码提示 */}
        <div className="contact-modal-desktop__scan-title">
          {t("contact_modal.scan_to_connect")}
        </div>
        <div className="contact-modal-desktop__scan-desc">
          {t("contact_modal.scan_desc")}
        </div>
      </div>
    </div>
  );

  // 移动端布局
  const renderMobileContent = () => (
    <div className="contact-modal-mobile-v2">
      {/* 上半部分：白色背景内容区 */}
      <div className="contact-modal-mobile-v2__content">
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="contact-modal-mobile-v2__close-btn"
          aria-label="Close"
        >
          ×
        </button>

        {/* 标题 */}
        <h2 className="contact-modal-mobile-v2__title">
          {t("contact_modal.title")}
        </h2>

        {/* Live Chat */}
        <div className="contact-modal-mobile-v2__section">
          <div className="contact-modal-mobile-v2__label">
            {t("contact_modal.live_chat")}
          </div>
          <div className="contact-modal-mobile-v2__text">
            {t("contact_modal.chat_desc")}
          </div>
        </div>

        {/* Support Email */}
        <div className="contact-modal-mobile-v2__section">
          <div className="contact-modal-mobile-v2__label">
            {t("contact_modal.support_email")}
          </div>
          <div className="contact-modal-mobile-v2__text">
            Send us an email at info@gen-optima.com for inquiries.
          </div>
        </div>

        {/* Support Phone */}
        <div className="contact-modal-mobile-v2__section">
          <div className="contact-modal-mobile-v2__label">
            {t("contact_modal.support_phone")}
          </div>
          <div className="contact-modal-mobile-v2__text">
            Call us at +1-(862) 235-0594 for immediate assistance.
          </div>
          <div className="contact-modal-mobile-v2__sub-text">
            {t("contact_modal.immediate_assistance")}
          </div>
        </div>

        {/* FAQ */}
        <div className="contact-modal-mobile-v2__section">
          <div className="contact-modal-mobile-v2__label">
            {t("contact_modal.faq_label")}
          </div>
          <div className="contact-modal-mobile-v2__text">
            {t("contact_modal.faq_desc")}
          </div>
        </div>
      </div>

      {/* 下半部分：主题色背景二维码区 */}
      <div className="contact-modal-mobile-v2__qr-section">
        <div className="contact-modal-mobile-v2__qr-wrapper">
          <img
            src={kefuQrCode}
            alt="QR Code"
            className="contact-modal-mobile-v2__qr-image"
          />
        </div>
        <div className="contact-modal-mobile-v2__scan-title">
          {t("contact_modal.scan_to_connect")}
        </div>
        <div className="contact-modal-mobile-v2__scan-desc">
          {t("contact_modal.scan_desc")}
        </div>
      </div>
    </div>
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={isMobile ? "80vw" : 720}
      rootClassName="contact-info-modal"
      style={{ maxWidth: "100%" }}
    >
      {isMobile ? renderMobileContent() : renderDesktopContent()}
    </Modal>
  );
};

export default ContactInfoModal;
